import $ from "jquery";
import scrollTo from "../utils/scrollToTop";

export const goToTheSpecificSectionFunc1 = (e, ref) => {
    return new Promise((resolve, reject) => {
        ref.setState({ marginBottom: 0, turn: 0 });
        let int = setInterval(_ => {
            if (ref.state.marginBottom === 0) { clearInterval(int); resolve(); };
        }, 50);
    }).then(_ => {
        let new_position = $(e).offset();
        scrollTo(new_position.top);
    });
};

export const goToTheSpecificSectionFunc2 = (e) => {
    let new_position = $(e).offset();
    scrollTo(new_position.top);
};


// WEBPACK FOOTER //
// ./src/utils/goToTheSpecificSection.js